import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-3" }
const _hoisted_2 = { class: "flex flex-grow items-center" }
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex flex-grow items-center justify-between" }
const _hoisted_5 = { class: "flex flex-col mb-3" }
const _hoisted_6 = { class: "flex flex-col mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Field, { field_name: "Aliquota iva" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.iva.descrizione), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Field, { field_name: "Residuo" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.toCurrency(_ctx.totaliIva.totale_ricavi - _ctx.totaliIva.pianificato)), 1),
            _createElementVNode("i", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyValue && _ctx.copyValue(...args))),
              class: "select-none flex justify-center items-center rounded h-8 w-8 border-2 hover:bg-next-neu cursor-pointer hover:text-white"
            }, "→")
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Field, {
        field_name: "Valore percentuale",
        modelValue: _ctx.valore_percentuale,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.valore_percentuale) = $event)),
          _ctx.percentualeChange
        ],
        type: "number",
        inputAttrs: {step:0.01},
        errors: _ctx.getErrors(`valore_percentuale`)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Field, {
        field_name: "Valore",
        required: !_ctx.valore,
        modelValue: _ctx.valore_model,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valore_model) = $event)),
          _ctx.valoreChange
        ],
        type: "number",
        inputAttrs: {step:0.01},
        errors: _ctx.getErrors('valore')
      }, null, 8, ["required", "modelValue", "onUpdate:modelValue", "errors"])
    ])
  ], 64))
}